module.exports = __webpack_public_path__ + "img/trees_4.2f1ee5c8.png";